import Component from '@ember/component';

/**
## Confirm Discard Changes Modal

Provides a base modal that detects keyDown events to track if any edits have
been made. If so, when the closeHandler is called showUncommittedChanges becomes
true and your handlebars could/should display a button having the user confirm
they want to discard their changes.

If your modal makes a network request (or some other asynchronous action) you
might want to prevent the user from closing the modal. Set stayOpen to true to
keep the modal open. It is the responsibility of the parent component to also
set stayOpen to false when the network request is complete.

e.g. orders/update-note-modal
*/
// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  hasBeenEdited: false,
  stayOpen: false,
  showUncommittedChanges: false,
  keyDown() {
    this.set('hasBeenEdited', true);
    this.set('showUncommittedChanges', false);
  },
  change() {
    this.set('hasBeenEdited', true);
    this.set('showUncommittedChanges', false);
  },
  didInsertElement(...args) {
    this._super(...args);
    this.setCloseHandler(() => {
      if (this.stayOpen) {
        return false;
      }
      if (this.hasBeenEdited) {
        this.set('showUncommittedChanges', true);
        return false; // do not close
      }
      return {
        didSave: false
      }; // allow closing
    });
  },
  cancel() {
    if (this.stayOpen) {
      return;
    }
    if (this.hasBeenEdited) {
      this.set('showUncommittedChanges', true);
    } else {
      this.confirmClose();
    }
  },
  confirmClose() {
    if (this.stayOpen) {
      return;
    }
    this.set('hasBeenEdited', false);
    this.set('showUncommittedChanges', false);
    this.close({
      didSave: false
    });
  }
});